import { withContextualizedTracking } from 'lib/analytics'
import { ChecklistAcqex } from './ChecklistAcqex'

export default withContextualizedTracking()(ChecklistAcqex)
